import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/ready.png'


const _withScopeId = n => (_pushScopeId("data-v-73fd4139"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
  /*#__PURE__*/_createElementVNode("section", null, [
    /*#__PURE__*/_createElementVNode("hr"),
    /*#__PURE__*/_createElementVNode("h1", { class: "ion-margin" }, "Welcome to Event Check-In App"),
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
    /*#__PURE__*/_createElementVNode("hr"),
    /*#__PURE__*/_createElementVNode("h4", null, "Let’s get started"),
    /*#__PURE__*/_createElementVNode("p", null, "Begin by creating your first event"),
    /*#__PURE__*/_createElementVNode("hr")
  ])
], -1))

import { arrowForward } from "ionicons/icons";
import {
  IonButton,
  IonIcon,
  IonPage,
  IonContent,
  useIonRouter,
} from "@ionic/vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'Welcome',
  setup(__props) {

const router = useIonRouter();
const goToEvent = () => {
  router.push(`/onboarding/new-event`);
};

const goToHome = () => {
  router.push(`/home`);
}

return (_ctx: any,_cache: any) => {
  const _component_ion_footer = _resolveComponent("ion-footer")!

  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), { class: "ion-text-center" }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_unref(IonButton), {
            size: "large",
            color: "light",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (goToEvent()))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonIcon), {
                slot: "start",
                icon: _unref(arrowForward)
              }, null, 8, ["icon"]),
              _createTextVNode(" Create event ")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_footer, { class: "ion-text-center" }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonButton), {
            size: "small",
            color: "light",
            fill: "clear",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (goToHome()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" SKIP ")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})